module.exports = __webpack_public_path__ + "static/media/thumbnail.12994dfe.jpg";